export default {
  Development: 'dev',
  Test: 'tst',
  Production: 'prd',
};
